/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const OpenShiftEmployeeStatusAction = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type OpenShiftEmployeeStatusAction = typeof OpenShiftEmployeeStatusAction[keyof typeof OpenShiftEmployeeStatusAction];



